
const ALL_BOTS = (base) => {
  const baseFormatted = base || ''

  const key = `${baseFormatted}peoplechat-allBots`

  return key
}

const ACTIVE_TABS = (base) => {
  const baseFormatted = base || ''

  const key = `${baseFormatted}peoplechat-activeTabs`

  return key
}

const USER_ID = (base) => {
  const baseFormatted = base || ''

  const key = `${baseFormatted}peoplechat-userId`

  return key
}

const WEBCHATSETTINGS = (base, tab, botId) => {
  const baseFormatted = base || ''

  if (botId) {
    const key = `${baseFormatted}${tab}/webChatSettings/${botId}`

    return key
  }

  return ''
}

export default {
  ALL_BOTS,
  ACTIVE_TABS,
  USER_ID,
  WEBCHATSETTINGS
}
